import React from 'react';
import styled from 'styled-components';

/**
 *
 * @param {*} param0
 * @returns {검색 전용 인풋}
 */
// onCustom : 온커스텀이 프롭스로 올 경우, 컴포넌트 내부에 있는 onChange 함수를 안탄다.
const SearchInputNoEvent = ({
  value,
  onChange,
  placeholder,
  onClick,
  onKeyPress,
}) => {
  return (
    <InputWrapper>
      <Input
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        onKeyPress={onKeyPress}
        onClick={onClick}
      />
    </InputWrapper>
  );
};

export default SearchInputNoEvent;

const InputWrapper = styled.div`
  position: relative;
  input,
  button {
    vertical-align: middle;
  }
`;

const Input = styled.input`
  width: 25rem;
  /* placeholder 꾸미기 */
  ::placeholder,
  ::-webkit-input-placeholder {
    padding-left: 5px;
    margin-bottom: 5px;
    color: #bdbdbd;
    padding: 5px;
  }
`;
